export default __webpack_public_path__ + "static/media/alert.fd78767d.svg";